import { Injectable } from "@angular/core";
import { ContatoreNoteDTO, ContatoreStatoNoteDTO } from "../dto/contatore-noteDTO";
import { ContatoreNoteVO, ContatoreStatoNoteVO } from "../vo/contatore-noteVO";

@Injectable({ providedIn: "root" })
export class MapperContatoreNote {
  convertDtoToVo(dto: ContatoreNoteDTO): ContatoreNoteVO {
    if (dto == null) {
      return null;
    }
    const vo = new ContatoreNoteVO();
    Object.keys(dto).forEach(tipoNota => {
      vo[tipoNota] = {};
      const statiDto: { [stato: string]: ContatoreStatoNoteDTO } = dto[tipoNota];
      Object.keys(statiDto).forEach(stato => {
        const s = new ContatoreStatoNoteVO();
        s.totali = statiDto[stato].totali;
        s.liberi = statiDto[stato].liberi;
        s.inCarico = statiDto[stato].inCarico;
        vo[tipoNota][stato] = s;
      });
    });
    return vo;
  }

  convertVoToDto(vo: ContatoreNoteVO): ContatoreNoteDTO {
    if (vo == null) {
      return null;
    }
    const dto = new ContatoreNoteDTO();
    Object.keys(vo).forEach(tipoNota => {
      dto[tipoNota] = {};
      const statiVo: { [stato: string]: ContatoreStatoNoteVO } = vo[tipoNota];
      Object.keys(statiVo).forEach(stato => {
        const s = new ContatoreStatoNoteDTO();
        s.totali = statiVo[stato].totali;
        s.liberi = statiVo[stato].liberi;
        s.inCarico = statiVo[stato].inCarico;
        dto[tipoNota][stato] = s;
      });
    });
    return dto;
  }
}
